export const FETCH_REQUEST_ACTION_PREFIX = 'FRA' as const;
export const fetchRequestActionRegExp = new RegExp(`^${FETCH_REQUEST_ACTION_PREFIX}`);
export const getFetchActionName = (name: string) => `${FETCH_REQUEST_ACTION_PREFIX}.${name}`;

export const REQUEST_ACTION_PREFIX = 'RA' as const;
export const requestActionRegExp = new RegExp(`^${REQUEST_ACTION_PREFIX}`);
export const getActionName = (name: string) => `${REQUEST_ACTION_PREFIX}.${name}`;
